function apiGetCall(apiname, params, cb) {
    jQuery.ajax({
        url:
            ajax.apiendpoint +
            "api/" +
            apiname +
            (window.debugerror == true ? "?error" : ""),
        data: params,
        type: "POST",
        success: function (result) {
          
          if (result.error) {
            cb(result.error, result);
          } else {
            cb(null, result);
          }
        }
    });
    return;
}

// function showAlertMessage(type, title, msg, btntitle, btnurl) {
//     $("#alertModal .modal-title")
//       .removeClass("error")
//       .removeClass("success")
//       .removeClass("warning");
//     $("#alertModal .modal-title")
//       .addClass(type)
//       .text(title);
//     $("#alertModal .modal-body p").text(msg);
//     $("#alertModal .modal-body p").html($("#alertModal .modal-body p").html().replace(/\n/g, '<br/>'));
  
//     $("#alertModal .modal-footer button").text(btntitle);
//     if (isEmpty(btnurl)) {
//       $("#alertModal .modal-footer button").attr("data-dismiss", "modal");
//     } else {
//       $("#alertModal .modal-footer button").removeAttr("data-dismiss");
//       $("#alertModal .modal-footer button,#alertModal").on("click", function (
//         event
//       ) {
//         event.preventDefault();
//         location.href = btnurl;
//       });
//     }
  
//       $("#alertModal").modal("show");
  
//       var  focusableElements =
//       'button, [href], a, .btn,  input, select, textarea, [tabindex]:not([tabindex="-1"])';
//       var modal = document.querySelector('#alertModal'); // select t
//       var firstFocusableElement = modal.querySelectorAll(focusableElements)[0]; 
  
//       firstFocusableElement.focus();
//   }